<script>
import StepText from "@/components/SignUp/Steps/StepText";

import { mapActions, mapState } from "vuex";
import errorMixin from "@/mixins/errorMixin";

export default {
  mixins: [errorMixin],

  components: {
    StepText
  },

  data() {
    return {
      first_name: "",
      last_name: "",
      cpf: "",
      birthdate: "",
      phone: ""
    };
  },

  computed: {
    ...mapState("signUp", ["legal_representative", "fieldErrors"])
  },

  methods: {
    ...mapActions("signUp", [
      "nextLegalStep",
      "prevLegalStep",
      "setLegalRepresentative"
    ]),

    async submit() {
      try {
        let dataIsValid = await this.$validator.validateAll();
        if (!dataIsValid) throw "Existem dados incorretos ou incompletos!";
        this.nextLegalStep();
      } catch (e) {
        this.$toasted.error(e);
      }
    }
  },

  mounted() {
    document.querySelector("input").focus();
    this.inputErrors(this.fieldErrors);
    if (this.legal_representative)
      Object.assign(this.$data, this.legal_representative);
  },

  beforeDestroy() {
    this.setLegalRepresentative(this.$data);
  }
};
</script>

<template>
  <form @submit.prevent="submit()">
    <step-text>Toda empresa tem um representante legal, precisamos que você nos informe os dados do seu representante:</step-text>

    <base-input
      :error="errors.first('Nome')"
      v-validate="'required|min:2|max:64|alpha_spaces'"
      v-model="first_name"
      label="Nome"
      custom-classes="capitalize"
    />

    <base-input
      :error="errors.first('Sobrenome')"
      v-validate="'required|min:2|max:64|alpha_spaces'"
      v-model="last_name"
      label="Sobrenome"
      custom-classes="capitalize"
    />

    <base-input
      :error="errors.first('cpf')"
      v-validate="'required|numeric|length:11'"
      v-model="cpf"
      label="CPF"
      name="cpf"
      data-vv-as="CPF"
      mask="###.###.###-##"
    />

    <base-input
      :error="errors.first('birthdate')"
      :masked="true"
      v-validate="'required|date_format:DD/MM/YYYY'"
      v-model="birthdate"
      label="Data de nascimento"
      name="birthdate"
      data-vv-as="Data de nascimento"
      mask="##/##/####"
    />

    <base-input
      :error="errors.first('Celular')"
      :mask="['(##) ####-####', '(##) #####-####']"
      v-validate="'required|numeric|min:10|max:11'"
      v-model="phone"
      label="Celular"
    />

    <base-flex justify="end" class="mt-10">
      <base-button @click="prevLegalStep()" outlined>voltar</base-button>
      <base-button type="submit">continuar</base-button>
    </base-flex>
  </form>
</template>



// WEBPACK FOOTER //
// src/components/SignUp/Steps/Accountable/Types/Legal/Representative.vue